/*
import tower from './images/tower-defense.png';
import wireframe from './images/wireframe.png';
import flutter from './images/flutter-theme.png';
import htf from './images/htf-homepage.jpg';
import nasmSite from './images/air-space-site.png';
import altText from './images/alt-text-checker.png';
import saam from './images/saam.png';
import amp from './images/amp.png';
*/

import game from './images/game-thumbnail.jpg';
import layout from './images/wireframe-thumbnail.jpg';
import logo from './images/flutter-thumbnail.jpg';
import access from './images/accessibility-thumbnail.jpg';

import nasmSite from './images/nasm-thumbnail.jpg';
import htf from './images/htf-thumbnail.jpg';
import saam from './images/saam-thumbnail.jpg';
import amp from './images/amp-thumbnail.jpg';

export const fourCardsIntroData = [
	{
		image: game,
		altText: 'Insert alt text.',
		title: 'Tower Defense Game',
		text: 'Web browser game built with the HTML5 Canvas API.',
		link: '/web-development#game',
		button: 'Play game',
	},
	{
		image: layout,
		altText: 'Insert alt text.',
		title: 'Alt Text Checker',
		text: 'Web application that checks best practices when writing alt text.',
		link: '/web-development#alt',
		button: 'Use alt text checker',
	},
	{
		image: logo,
		altText: 'Insert alt text.',
		title: 'Code Samples and Web Designs',
		text: 'Custom API and automated testing, as well as wireframes and mock-ups.',
		link: '/web-development#samples',
		button: 'View wireframes',
	},
	{
		image: access,
		altText: 'Insert alt text.',
		title: 'Flutter Applications and Computer Networking',
		text: 'Videos demoing Flutter SDK applications and teaching computer networking concepts.',
		link: '/web-development#video',
		button: 'View css animations',
	},

]

export const fourCardsManageData = [
	{
		image: nasmSite,
		altText: 'Insert alt text.',
		title: 'Smithsonian National Air and Space Museum Website',
		text: 'I am the product owner for the National Air and Space Museum’s main website.  I shepherded the site from Drupal 7 through upgrades and redesigns eventually becoming the current Drupal 9 site.',
		link: 'https://airandspace.si.edu/',
		button: 'Visit the website',
	},
	{
		image: htf,
		altText: 'Insert alt text.',
		title: 'How Things Fly Website',
		text: 'I project managed the upgrade of the How Things Fly site from Drupal 6 to Drupal 8 and managed the migration of 12 Flash interactives to ReactJS and 2 Unity interactives to the most recent version of Unity.',
		link: 'https://howthingsfly.si.edu',
		button: 'Visit the website',
	},
	{
		image: saam,
		altText: 'Insert alt text.',
		title: 'Smithsonian American Art Museum Website',
		text: 'I managed content and helped facilitate the migration of the American Art Museum’s website from ColdFusion to Drupal 8. ',
		link: 'https://americanart.si.edu',
		button: 'Visit the website',
	},
	{
		image: amp,
		altText: 'Insert alt text.',
		title: 'Google AMP Apollo 50 Applications',
		text: 'I worked with Google to develop 20 Accelerated Mobile Page (AMP) applications in celebration of the Apollo 50th anniversary.',
		link: 'https://airandspace.si.edu/amp-stories/margaret-hamilton/',
		button: 'Visit the website',
	},

]